import { jsxs as o, jsx as r } from "react/jsx-runtime";
import { useRef as R } from "react";
import { RocheUIHeroVariant as v } from "../../types/roche-hero-variant.js";
import { RocheUIStoryType as I } from "../../types/roche-story-type.js";
import { RocheUIIcon as u } from "../icon/roche-icon.js";
import { RocheUIIconVariant as U } from "../story-teaser/roche-story-teaser.types.js";
import e from "./roche-story-staging-hero.module.scss.js";
const F = ({
  variant: t,
  storyHeadline: n,
  storyDescription: h,
  storyType: a,
  storyTypeTranslation: l,
  storyTags: i,
  showTags: g,
  Image: c,
  slot: d
}) => {
  const s = t === v.VARIANT_B, m = R(null), _ = [e["story-staging-hero"], e[t]].filter(Boolean).join(" "), p = s && g && i && i.length > 0, y = U[a] ?? "", N = s && a && a !== I.DEFAULT, f = s && c;
  return /* @__PURE__ */ o("section", { ref: m, className: _, "data-variant": t, slot: d, children: [
    /* @__PURE__ */ o("div", { className: e["story-staging-hero__wrapper"], children: [
      /* @__PURE__ */ r("div", { className: e["story-staging-hero__background"] }),
      /* @__PURE__ */ o("div", { className: e["story-staging-hero__content"], children: [
        /* @__PURE__ */ r("div", { className: e["story-staging-hero__letter"] }),
        N && /* @__PURE__ */ o("div", { className: e["story-staging-hero__story-type-wrapper"], children: [
          /* @__PURE__ */ r("span", { className: e["story-staging-hero__icon"], children: /* @__PURE__ */ r(u, { icon: y, height: "24px" }) }),
          /* @__PURE__ */ r("span", { className: e["story-staging-hero__story-type"], children: l })
        ] }),
        /* @__PURE__ */ o("div", { className: e["story-staging-hero__header"], children: [
          n && /* @__PURE__ */ r("h1", { className: e["story-staging-hero__headline"], children: n }),
          p && /* @__PURE__ */ r("div", { className: e["story-staging-hero__tag-wrapper"], children: i })
        ] }),
        !s && /* @__PURE__ */ r("p", { className: e["story-staging-hero__text"], children: h })
      ] }),
      /* @__PURE__ */ r("div", { className: e["story-staging-hero__divider"] })
    ] }),
    f && /* @__PURE__ */ r("div", { className: e["story-staging-hero__image"], children: c })
  ] });
};
export {
  F as RocheUIStoryStagingHero
};
